import type { Asset } from '@schibsted-svp/svp-api-types';

import type { HttpClient, HttpClientOptions } from './httpClient';

const getRelatedAssets =
  (client: HttpClient) =>
  async (params: {
    assetId: Asset['id'] | number;
    limit?: number;
    filters?: string[];
    options?: HttpClientOptions;
  }): Promise<Asset[]> => {
    const searchParams = new URLSearchParams();
    const { assetId, limit, filters: customFilters = [], options } = params;

    const filters = ['category.showCategory::true', ...customFilters];
    searchParams.set('filter', filters.join('|'));

    if (limit) {
      searchParams.set('limit', String(limit));
    }

    const response = await client(`/${assetId}`, {
      ...options,
      searchParams,
    });

    return response.json();
  };

export type RelatedApiClient = ReturnType<typeof createRelatedApi>;

export const createRelatedApi = (client: HttpClient) => {
  return {
    getRelatedAssets: getRelatedAssets(client),
  };
};
